import React from 'react';
import {
  IPerformedCohortFieldsFragment,
  TimeWindowKey,
} from '../../../../utils/apollo/graphqlSchema';
import EventConditionInfo from '../EventConditionInfo';
import InfoPopupHeaderSetting from '../InfoPopupHeaderSetting';
import * as BuilderInfoUI from '../../BuilderInfoUI';
import { CohortConditionIcon } from '../../../Icon';
import CohortDetailsDateRange from './CohortDetailsDateRange';
import { CohortDetailsBorderedInfo } from './CohortDetailsUI';

interface IProps {
  cohort: IPerformedCohortFieldsFragment;
  cohortIndex: number;
}

export default ({ cohort, cohortIndex }: IProps) => {
  const {
    type,
    operator,
    timeWindow,
    timeWindowValues,
    performedOperatorValues,
    eventConditions,
    datePicker,
    subject,
  } = cohort;

  return (
    <>
      <BuilderInfoUI.HeaderContainer>
        <CohortConditionIcon conditionIndex={cohortIndex} />
        <InfoPopupHeaderSetting label={'Subject'}>
          {subject.name}
        </InfoPopupHeaderSetting>
        <InfoPopupHeaderSetting label={'Type'}>
          {type.name}
        </InfoPopupHeaderSetting>
        <CohortDetailsDateRange datePicker={datePicker} />
        <CohortDetailsBorderedInfo>{operator.name}</CohortDetailsBorderedInfo>
        {performedOperatorValues?.length > 0 && (
          <>
            <CohortDetailsBorderedInfo>
              {performedOperatorValues[0]}
            </CohortDetailsBorderedInfo>
            {performedOperatorValues.length === 2 && (
              <>
                <div>and</div>
                <CohortDetailsBorderedInfo>
                  {performedOperatorValues[1]}
                </CohortDetailsBorderedInfo>
              </>
            )}
          </>
        )}
        <CohortDetailsBorderedInfo>{timeWindow.name}</CohortDetailsBorderedInfo>
        {timeWindowValues?.length > 0 && (
          <>
            <CohortDetailsBorderedInfo>
              {timeWindowValues[0]}
            </CohortDetailsBorderedInfo>
            {timeWindowValues.length === 2 && (
              <>
                <div>and</div>
                <CohortDetailsBorderedInfo>
                  {timeWindowValues[1]}
                </CohortDetailsBorderedInfo>
              </>
            )}
          </>
        )}
        {timeWindow.key !== TimeWindowKey.Overall && <div>day(s)</div>}
      </BuilderInfoUI.HeaderContainer>
      <BuilderInfoUI.VerticalNestedRow>
        {eventConditions.map((eventCondition, index) => (
          <EventConditionInfo
            key={'condition-key' + index}
            condition={eventCondition}
            label={'Event(s)'}
            noMarginBottom
          />
        ))}
      </BuilderInfoUI.VerticalNestedRow>
    </>
  );
};
